import getEnv from './env';

export default function () {
  const env = getEnv();
  if (env === 'PROD') {
    return 'https://cdn.gladly.com';
  }
  return 'https://cdn.gladly.qa';
}
